import appEndpoint from '../utility/appEndpoint';
import CommonFunctions from '../utility/CommonFunctions';
import ServiceClient from './index';

export default class CommonService extends ServiceClient {

  auditLog(requestURI) {
    const reqOptions = {
      url: appEndpoint.auditLogs,
      data: {
        pageReqURI: requestURI
      },
    };

    return this.requestApi(
      reqOptions,
    )
      .post();
  }

  logReactErrors(error = null, componentName = '', methodName = '', errorInfo = null) {
    const reqOptions = {
      url: appEndpoint.appLog,
      data: {
        error: !CommonFunctions.isEmpty(error?.error) && typeof error?.error === 'object' ?
          JSON.stringify(error?.error) : error,
        componentName: componentName,
        methodName: methodName,
        errorInfo: errorInfo
      }
    };
    return this.requestApi(
      reqOptions,
    )
      .post();
  }
}